//private creds
export const API_BASE_URL = process.env.API_BASE_URL;
export const API_SUBSCRIPTION_KEY = process.env.API_SUBSCRIPTION_KEY || '';
export const D365_API_BASE_URL = process.env.D365_API_BASE_URL;
export const D365_API_SUBSCRIPTION_KEY = process.env.D365_API_SUBSCRIPTION_KEY || '';
export const SITE_URL = process.env.SITE_URL;
export const BLOB_STORAGE_URL = process.env.BLOB_STORAGE_URL;

//public creds
export const CT_STOREKEY = process.env.NEXT_PUBLIC_CT_STOREKEY;
export const CONTACT_US = process.env.NEXT_PUBLIC_CONTACT_US;
export const SITE_URL_PUBLIC = process.env.NEXT_PUBLIC_SITE_URL;
export const FEEDBACK_URL = process.env.NEXT_PUBLIC_FEEDBACK_URL;
export const NEXT_PUBLIC_IMAGE_CDN = process.env.NEXT_PUBLIC_IMAGE_CDN;
